import { defaultRoles } from "../../util/workshop.util";
import { CountdownTimer, Participant } from "./";

const GroupList = ({ groups, groupTaskStatus, socket, taskId, isOnline = false }) => {
  return (
    <>
      {groups.map((group, index) => (
        <div
          key={index}
          className={`relative flex flex-row justify-between gap-4  rounded-lg items-center`}>
          <div className="flex flex-row gap-2 items-center mt-2">
            <Participant
              name={`Group ${index + 1}`}
              role={defaultRoles.participant}
              moderator={true}
            />
          </div>
          <div>
            {groupTaskStatus?.[index]?.finished ? (
              <div className="flex flex-row gap-2 items-center bg-green-500 rounded-2xl px-6 py-2 bg-opacity-40">
                <p className="text-black-100">Ready</p>
              </div>
            ) : (
              <CountdownTimer
                id={`${taskId}-${index}`}
                start={groupTaskStatus?.[index]?.started}
                totalTime={210}
                finished={groupTaskStatus?.[index]?.finished}
                trailColor={isOnline ? "#fff" : undefined}
                textColor={isOnline ? "#E59536" : undefined}
                strokeWidth={isOnline ? 5 : undefined}
                size={isOnline ? 65 : undefined}
                orangeClock={isOnline}
                onReset={
                  isOnline
                    ? null
                    : () => {
                        socket.emit("updateGroupTaskStatus", {
                          taskId: taskId,
                          groupId: index,
                          started: true,
                          ready: true,
                          finished: false,
                          remainingTime: 210,
                          timerId: `${taskId}-${index}`
                        });
                      }
                }
                greyedOnCompletion
                // customClass={`absolute right-0 ${group?.length === 2 ? "top-[55%]" : "top-1/2"} -translate-y-1/2 -translate-x-1/4`}
              />
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export default GroupList;
